import React from "react";
import {
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function CustomToolbar({
  onOpenFilterModelManager,
  currentFilterModel,
  onDeselectFilterModel,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <GridToolbarContainer
      sx={{ justifyContent: isMobile ? "flex-end" : "flex-start" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-end" : "center",
          width: isMobile ? "auto" : "100%",
          gap: isMobile ? 1 : 0,
        }}
      >
        {!isMobile && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <GridToolbarColumnsButton />
            <GridToolbarDensitySelector />
          </Box>
        )}
        <GridToolbarFilterButton
          sx={{ justifyContent: isMobile ? "flex-start" : "center" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: isMobile ? "100%" : "auto",
            ml: isMobile ? 0 : 1,
          }}
        >
          <Button
            onClick={onOpenFilterModelManager}
            className="filter-model-button"
            sx={{
              pr: currentFilterModel ? 1 : 2,
              flexGrow: isMobile ? 1 : 0,
              justifyContent: isMobile ? "flex-start" : "center",
            }}
          >
            {currentFilterModel?.name
              ? `Filter - ${currentFilterModel.name}`
              : "Manage Filter Models"}
          </Button>
          {currentFilterModel?.name && (
            <Tooltip title="Deselect filter model">
              <IconButton
                size="small"
                onClick={onDeselectFilterModel}
                sx={{ ml: -1 }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <GridToolbarQuickFilter
          placeholder="Quick Filter..."
          sx={{ width: isMobile ? "100%" : "auto", ml: isMobile ? 0 : 1 }}
        />
      </Box>
    </GridToolbarContainer>
  );
}

export default CustomToolbar;
